<div class="uploader mb-3 d-flex justify-content-center align-items-center"
  [class.portrait]="orientation() === 'portrait'"
  [class.landscape]="orientation() === 'landscape'"
  [class.square]="orientation() === 'square'">
  @if (!url() && !uploading()) {
    <div class="placeholder d-flex flex-column justify-content-center align-items-center">
      <input type="file" (change)="onFileSelected($event)" style="display: none;" #fileInput accept="image/*">
      <button mat-flat-button color="primary" (click)="openFileInput($event)">Upload Image</button>
    </div>
  }
  @if (uploading()) {
    <xui-loading-spinner></xui-loading-spinner>
  }
  @if (url() && !uploading()) {
    <xmed-image-view [fileKey]="url()" [legacy]="legacy()"></xmed-image-view>
  }
  @if (url() && !uploading()) {
    <button mat-icon-button class="delete-button" (click)="removeImage()"><mat-icon>delete</mat-icon></button>
  }
</div>
